module["exports"] = [
  "AB",
  "BC",
  "MB",
  "NB",
  "NL",
  "NS",
  "NU",
  "NT",
  "ON",
  "PE",
  "QC",
  "SK",
  "YT"
];



//////////////////
// WEBPACK FOOTER
// ./~/faker/lib/locales/en_CA/address/state_abbr.js
// module id = 2135
// module chunks = 2